import Player from './Player.vue';
import Preview from './Preview.vue';

export default {
  Player,
  Preview,
};
